var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTotalRiskRules(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "2aw7k487la",
    d: "M0 0h1.01v3.024H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "wcjy1mcfpc",
    d: "M0 0h2.967v1.03H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "vfcc5odkve",
    d: "M0 0h15.832v15.77H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.843 3.732a.503.503 0 0 0 .358-.15l1.389-1.416a.522.522 0 0 0 0-.73.503.503 0 0 0-.716 0l-1.389 1.417a.525.525 0 0 0 0 .75.49.49 0 0 0 .358.129z",
    fill: "#FF6F57"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.654)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "42mt03ypnb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#2aw7k487la"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.505 3.024a.504.504 0 0 0 .505-.515V.515A.517.517 0 0 0 .505 0 .517.517 0 0 0 0 .515v1.994c0 .279.232.515.505.515",
    fill: "#FF6F57",
    mask: "url(#42mt03ypnb)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.139 3.582a.502.502 0 0 0 .716 0 .525.525 0 0 0 0-.751l-1.39-1.416c-.19-.193-.526-.193-.737 0a.522.522 0 0 0 0 .73l1.41 1.437zM17.2 6.241a.502.502 0 0 0-.736 0 .525.525 0 0 0 0 .751l1.39 1.416a.502.502 0 0 0 .716 0 .525.525 0 0 0-.001-.751L17.2 6.24z",
    fill: "#FF6F57"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.033 4.397)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "1t3gqtyn3d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#wcjy1mcfpc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.462 0H.505A.517.517 0 0 0 0 .515c0 .279.231.515.505.515h1.957a.504.504 0 0 0 .505-.515A.517.517 0 0 0 2.462 0",
    fill: "#FF6F57",
    mask: "url(#1t3gqtyn3d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 4.23)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o8ycx71lef",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#vfcc5odkve"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.846 13.25c-.59 0-1.074-.494-1.074-1.094 0-.6.484-1.094 1.074-1.094.589 0 1.073.493 1.073 1.094 0 .6-.484 1.094-1.073 1.094zM6.76 4.456a.953.953 0 0 1 1.032.88v.15l-.316 3.946a.645.645 0 0 1-.695.6c-.315-.02-.547-.278-.589-.6l-.316-3.946a.97.97 0 0 1 .884-1.03zM14.696.209c-1.22 1.223-2 1.866-2.441 2.188l-.421-.429a.99.99 0 0 0-1.431 0l-.61.622a6.698 6.698 0 0 0-7.788 1.33c-2.673 2.702-2.673 7.099 0 9.823a6.744 6.744 0 0 0 9.64 0c2.104-2.145 2.546-5.362 1.304-7.936l.61-.622c.4-.407.4-1.05 0-1.458l-.336-.343c.526-.408 1.326-1.073 2.42-2.21a.71.71 0 0 0 0-.965c-.273-.279-.694-.279-.947 0z",
    fill: "#FF6F57",
    mask: "url(#o8ycx71lef)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalRiskRules);
export default __webpack_public_path__ + "static/media/total-risk-rules.04341550.svg";
export { ForwardRef as ReactComponent };